export const getTrackingTeamName = teamContext => {
  if (!teamContext?.data) return '';
  const { schoolName, schoolCity, stateCode, season, gender, level, sport } =
    teamContext.data;
  return `${schoolName} (${schoolCity}, ${stateCode})  ${season} ${gender} ${level} ${sport}`;
};
